"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synCheckSecurity = exports.synRights = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("@progress/kendo-ui");
const Utilities_1 = require("./Utilities");
var synRights;
(function (synRights) {
    synRights[synRights["Create"] = 1] = "Create";
    synRights[synRights["Unused_1"] = 2] = "Unused_1";
    synRights[synRights["Search"] = 4] = "Search";
    synRights[synRights["ChangeProp"] = 8] = "ChangeProp";
    synRights[synRights["Unused_2"] = 16] = "Unused_2";
    synRights[synRights["ChangeSec"] = 32] = "ChangeSec";
    synRights[synRights["Unused_3"] = 64] = "Unused_3";
    synRights[synRights["ChangeStruct"] = 128] = "ChangeStruct";
    synRights[synRights["ViewStruct"] = 256] = "ViewStruct";
    synRights[synRights["ChangeCont"] = 512] = "ChangeCont";
    synRights[synRights["ViewCont"] = 1024] = "ViewCont";
    synRights[synRights["Delete"] = 2048] = "Delete";
    synRights[synRights["Unused_4"] = 4096] = "Unused_4";
    synRights[synRights["Unused_5"] = 8192] = "Unused_5";
    synRights[synRights["Unused_6"] = 16384] = "Unused_6";
    synRights[synRights["Version"] = 32768] = "Version";
    synRights[synRights["Unused_7"] = 65536] = "Unused_7";
    synRights[synRights["Execute"] = 131072] = "Execute";
    synRights[synRights["ChangeState"] = 262144] = "ChangeState";
    synRights[synRights["Overwrite"] = 524288] = "Overwrite";
    synRights[synRights["AddStruct"] = 1048576] = "AddStruct";
    synRights[synRights["RemoveStruct"] = 2097152] = "RemoveStruct";
    synRights[synRights["ChangePartialProperty"] = 4194304] = "ChangePartialProperty";
    synRights[synRights["ChangePartialCont"] = 8388608] = "ChangePartialCont";
    synRights[synRights["Download"] = 268435456] = "Download";
    synRights[synRights["ViewPartialContent"] = 536870912] = "ViewPartialContent";
    synRights[synRights["UnDelete"] = 1073741824] = "UnDelete";
})(synRights = exports.synRights || (exports.synRights = {}));
class synCheckSecurity {
    static checkSecurityInstance(instanceId, rights) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let data = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.m_defaultWSUrlPrefix + "Security/checkSecurityInstance/",
                    requestData: {
                        id: instanceId,
                        rights: JSON.stringify(rights),
                    }
                });
                return data === true;
            }
            catch (ex) {
                return Promise.reject(ex);
            }
        });
    }
    static checkSecurityAcl(aclId, rights) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let data = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.m_defaultWSUrlPrefix + "Security/checkSecurityAcl/",
                    requestData: {
                        id: aclId,
                        rights: JSON.stringify(rights),
                    }
                });
                return data === true;
            }
            catch (ex) {
                return Promise.reject(ex);
            }
        });
    }
}
exports.synCheckSecurity = synCheckSecurity;
